// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var FromJSONKeyString = /* #__PURE__ */ (function () {
    function FromJSONKeyString(value0) {
        this.value0 = value0;
    };
    FromJSONKeyString.create = function (value0) {
        return new FromJSONKeyString(value0);
    };
    return FromJSONKeyString;
})();
var FromJSONKeyValue = /* #__PURE__ */ (function () {
    function FromJSONKeyValue(value0) {
        this.value0 = value0;
    };
    FromJSONKeyValue.create = function (value0) {
        return new FromJSONKeyValue(value0);
    };
    return FromJSONKeyValue;
})();
var fromJSONKeyString = /* #__PURE__ */ (function () {
    return {
        fromJSONKey: new FromJSONKeyString(Control_Category.identity(Control_Category.categoryFn))
    };
})();
var decodeUnit = {
    unsafeDecode: function (v) {
        return Data_Unit.unit;
    }
};
var decodeString1 = {
    unsafeDecode: $foreign.decodeString
};
var decodeRecordNil = {
    recordInfo: function (v) {
        return $foreign.recordInfoNil;
    }
};
var decodeNumber1 = {
    unsafeDecode: $foreign.decodeNumber
};
var decodeInt1 = {
    unsafeDecode: $foreign.decodeInt
};
var decodeForeign = {
    unsafeDecode: function (x) {
        return x;
    }
};
var decodeBoolean1 = {
    unsafeDecode: $foreign.decodeBoolean
};
var unsafeDecode = function (dict) {
    return dict.unsafeDecode;
};
var decodeArray1 = function (dictDecode) {
    return {
        unsafeDecode: $foreign.decodeArray(unsafeDecode(dictDecode))
    };
};
var decodeMaybe = function (dictDecode) {
    return {
        unsafeDecode: function (value) {
            var $52 = Foreign.isNull(value) || Foreign.isUndefined(value);
            if ($52) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(unsafeDecode(dictDecode)(value));
        }
    };
};
var decodeNonEmptyArray = function (dictDecode) {
    return {
        unsafeDecode: function (f) {
            var v = Data_Array_NonEmpty.fromArray($foreign.decodeArray(unsafeDecode(dictDecode))(f));
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return $foreign.decodingError("NonEmptyArray should not be empty");
            };
            throw new Error("Failed pattern match at Unscramble (line 63, column 5 - line 67, column 58): " + [ v.constructor.name ]);
        }
    };
};
var decodeObject1 = function (dictDecode) {
    return {
        unsafeDecode: $foreign.decodeObject(unsafeDecode(dictDecode))
    };
};
var decodeSet = function (dictDecode) {
    return function (dictOrd) {
        return {
            unsafeDecode: (function () {
                var $66 = Data_Set.fromFoldable(Data_Foldable.foldableArray)(dictOrd);
                var $67 = $foreign.decodeArray(unsafeDecode(dictDecode));
                return function ($68) {
                    return $66($67($68));
                };
            })()
        };
    };
};
var decodeTuple = function (dictDecode) {
    return function (dictDecode1) {
        return {
            unsafeDecode: function (v) {
                var v1 = $foreign.expectArray(v);
                if (v1.length === 2) {
                    return new Data_Tuple.Tuple(unsafeDecode(dictDecode)(v1[0]), unsafeDecode(dictDecode1)(v1[1]));
                };
                return $foreign.decodingError("Invalid array length in Tuple representation");
            }
        };
    };
};
var recordInfo = function (dict) {
    return dict.recordInfo;
};
var decodeRecord1 = function () {
    return function (dictDecodeRecord) {
        return {
            unsafeDecode: $foreign.decodeRecord(recordInfo(dictDecodeRecord)(Type_Proxy["Proxy"].value))
        };
    };
};
var decodeRecordCons = function (dictIsSymbol) {
    return function (dictDecode) {
        return function (dictDecodeRecord) {
            return {
                recordInfo: function (v) {
                    return $foreign.recordInfoCons(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value))(unsafeDecode(dictDecode))(recordInfo(dictDecodeRecord)(Type_Proxy["Proxy"].value));
                }
            };
        };
    };
};
var fromJSONKey = function (dict) {
    return dict.fromJSONKey;
};
var decodeMap = function (dictFromJSONKey) {
    return function (dictOrd) {
        return function (dictDecode) {
            return {
                unsafeDecode: function (v) {
                    var v1 = fromJSONKey(dictFromJSONKey);
                    if (v1 instanceof FromJSONKeyString) {
                        return Data_FoldableWithIndex.foldlWithIndex(Foreign_Object.foldableWithIndexObject)(function (k) {
                            return function (acc) {
                                return function (v2) {
                                    return Data_Map_Internal.insert(dictOrd)(v1.value0(k))(unsafeDecode(dictDecode)(v2))(acc);
                                };
                            };
                        })(Data_Map_Internal.empty)($foreign.expectObject(v));
                    };
                    if (v1 instanceof FromJSONKeyValue) {
                        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (acc) {
                            return function (v2) {
                                return Data_Map_Internal.insert(dictOrd)(v1.value0(v2.value0))(unsafeDecode(dictDecode)(v2.value1))(acc);
                            };
                        })(Data_Map_Internal.empty)(unsafeDecode(decodeArray1(decodeTuple(decodeForeign)(decodeForeign)))(v));
                    };
                    throw new Error("Failed pattern match at Unscramble (line 106, column 5 - line 110, column 142): " + [ v1.constructor.name ]);
                }
            };
        };
    };
};
var defaultFromJSONKeyValue = function (dictDecode) {
    return new FromJSONKeyValue(unsafeDecode(dictDecode));
};
var catchDecodingErrorEither = /* #__PURE__ */ (function () {
    return $foreign.catchDecodingErrorImpl(Data_Either.Left.create)(Data_Either.Right.create);
})();
var decodeEither = function (dictDecode) {
    return function (value) {
        return catchDecodingErrorEither(function (v) {
            return unsafeDecode(dictDecode)(value);
        });
    };
};
var decodeJSONEither = function (dictDecode) {
    return function (value) {
        return catchDecodingErrorEither(function (v) {
            return unsafeDecode(dictDecode)($foreign.unsafeParseJSON(value));
        });
    };
};
var catchDecodingError = /* #__PURE__ */ (function () {
    return $foreign.catchDecodingErrorImpl(function (v) {
        return Data_Maybe.Nothing.value;
    })(Data_Maybe.Just.create);
})();
var decode = function (dictDecode) {
    return function (value) {
        return catchDecodingError(function (v) {
            return unsafeDecode(dictDecode)(value);
        });
    };
};
var decodeJSON = function (dictDecode) {
    return function (value) {
        return catchDecodingError(function (v) {
            return unsafeDecode(dictDecode)($foreign.unsafeParseJSON(value));
        });
    };
};
export {
    decodingError,
    recordInfoNil,
    recordInfoCons,
    decodeRecord,
    isString,
    decodeString,
    isNumber,
    decodeNumber,
    decodeInt,
    decodeBoolean,
    decodeArray,
    decodeObject,
    expectObject,
    expectArray,
    unsafeParseJSON,
    catchDecodingErrorImpl
} from "./foreign.js";
export {
    fromJSONKey,
    recordInfo,
    unsafeDecode,
    decode,
    decodeEither,
    decodeJSON,
    decodeJSONEither,
    defaultFromJSONKeyValue,
    FromJSONKeyString,
    FromJSONKeyValue,
    catchDecodingError,
    catchDecodingErrorEither,
    decodeForeign,
    decodeUnit,
    decodeString1,
    decodeNumber1,
    decodeInt1,
    decodeBoolean1,
    decodeArray1,
    decodeNonEmptyArray,
    decodeTuple,
    decodeObject1,
    decodeRecord1,
    decodeMaybe,
    decodeSet,
    fromJSONKeyString,
    decodeMap,
    decodeRecordNil,
    decodeRecordCons
};
//# sourceMappingURL=index.js.map
